import React from 'react';
import Box from '@mui/material/Box';

// Renders Quill-authored HTML with consistent spacing/typography, without
// touching the stored markup or the editor. Authors often press Enter for
// spacing instead of using margins, leaving empty <p>/<hX><br></hX> spacer
// elements — those get collapsed to a small gap here instead of a full
// line's worth of empty space.
const emptyBlockSelector = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']
    .map(tag => `& ${tag}:has(> br:only-child)`)
    .join(', ');

const PostContent = ({ html, sx, ...props }) => (
    <Box
        sx={{
            color: 'text.primary',
            lineHeight: 1.6,
            '& > :first-of-type': { mt: 0 },
            '& > :last-child': { mb: 0 },
            '& p, & h1, & h2, & h3, & h4, & h5, & h6': {
                margin: '0.6em 0',
            },
            '& h1': { fontSize: '1.8rem', fontWeight: 600 },
            '& h2': { fontSize: '1.5rem', fontWeight: 600 },
            '& h3': { fontSize: '1.3rem', fontWeight: 600 },
            '& h4': { fontSize: '1.15rem', fontWeight: 600 },
            '& h5': { fontSize: '1.05rem', fontWeight: 600 },
            '& h6': { fontSize: '1rem', fontWeight: 600 },
            [emptyBlockSelector]: {
                margin: '0.2em 0',
                minHeight: '0.6em',
            },
            '& img': {
                maxWidth: '100%',
                height: 'auto',
                borderRadius: 1,
                display: 'inline-block',
                verticalAlign: 'middle',
                margin: '6px',
                boxShadow: 2,
            },
            '& a': {
                color: 'primary.main',
            },
            '& ul, & ol': {
                margin: '0.6em 0',
                paddingLeft: '1.5em',
            },
            ...sx,
        }}
        dangerouslySetInnerHTML={{ __html: html }}
        {...props}
    />
);

export default PostContent;
